import { analytics, errorCode } from "./posthog";
/** Summarize background writes separately from user tool usage. */
export class PersistenceHealth {
  private successes = 0;
  private failures = 0;
  private lastFailure = "none";
  private notifiedFailure = false;
  /** Accept only aggregate counters at the transport boundary. */
  constructor(
    private readonly send: (
      success: number,
      failure: number,
      code: string,
    ) => void,
  ) {}
  /** Notify the first failed write immediately and include it in exactly one summary. */
  record(success: boolean, error?: unknown): void {
    if (success) {
      this.successes++;
    } else {
      this.failures++;
      this.lastFailure = errorCode(error);
    }
    if (!success && !this.notifiedFailure) {
      this.notifiedFailure = true;
      this.flush();
    }
  }
  /** Flush counters after a reporting window or when the page becomes hidden. */
  flush(): void {
    if (!this.successes && !this.failures) {
      return;
    }
    this.send(this.successes, this.failures, this.lastFailure);
    this.successes = 0;
    this.failures = 0;
    this.lastFailure = "none";
  }
}
export const persistenceHealth = new PersistenceHealth(
  (success, failure, code) => analytics.health(success, failure, code),
);
/** Install a single timer and flush pending counters on page hide. */
export const initializePersistenceHealth = (): void => {
  window.setInterval(() => persistenceHealth.flush(), 60_000);
  window.addEventListener("pagehide", () => persistenceHealth.flush());
};
